import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { faqs } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-ivory py-24 sm:py-28 lg:py-36" data-id="element-69" data-mp="1ge0ggq1ex0en">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-12" data-id="element-70" data-mp="2e0zeb43ucee4">
        <Reveal data-id="element-71" data-mp="292edp3kofsp5">
          <SectionLabel data-id="element-72" data-mp="291weby2pwyd0">Good to know</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4vw,3.25rem)] font-light leading-[1.08] text-forest-deep" data-id="element-73" data-mp="241qrcv7e8019">
            Frequently asked questions
          </h2>
          <p className="mt-6 text-[15px] leading-relaxed text-forest-deep/60" data-id="element-74" data-mp="1z5jiatjpa8f3">
            Still have a question? Message us directly and we will get back to
            you personally.
          </p>
          <a href="#book" className="mt-8 inline-block rounded-full border border-forest/30 px-7 py-3.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-forest-deep transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:border-forest hover:bg-forest hover:text-ivory" data-id="element-75" data-mp="nqd1bqiwv1ze">
            Get in touch
          </a>
        </Reveal>

        <Reveal delay={0.1} data-id="element-76" data-mp="kh0bcl9f83hu">
          <ul className="border-t border-sand-dark/60" data-id="element-77" data-mp="6rgd9sqsbuev">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <li key={faq.question} className="border-b border-sand-dark/60" data-id="element-78" data-mp="bjhjoy19uqwz" data-mpi={i}>
                  <h3 data-id="element-79" data-mp="3szzdg5d69ypv">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-300 hover:text-ocean" data-id="element-80" data-mp="3swjyr3neuroz">
                      <span className="text-[16px] font-medium text-forest-deep sm:text-[17px]" data-id="element-81" data-mp="1uixl94ro9d6w">
                        {faq.question}
                      </span>
                      <Plus className={`h-5 w-5 flex-shrink-0 text-gold transition-transform duration-500 ease-calm ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-82" data-mp="1ks2vvrj4pxh8" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-83" data-mp="28esz2w77ry3f">
                    {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.45,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-84" data-mp="23fpvzhaso1y3">
                        <p className="max-w-2xl pb-7 pr-10 text-[15px] leading-[1.8] text-forest-deep/65" data-id="element-85" data-mp="33ppg9p1aih4w">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}